module.exports = __webpack_public_path__ + "static/media/glowBall2.07d960b6.mp4";